import { getErrorMessage } from "store/helper";
import { crudService } from "services/crud.service";
import { NotificationManager } from "react-notifications";
import { initialAdminProperyState } from "store/constants";
import { apiFail, apiSuccess, endPoints } from "utils/constants";
import { PayloadAction, createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const { inventoryEndPoint, individualPropertyEndPoint } = endPoints;

export const addAdminInventoryBulk = createAsyncThunk(
  "properties/addAdminInventoryBulk",
  async (
    {
      properties: newProperties,
      onProgress,
    }: { properties: any; onProgress?: (progress: number) => void },
    { rejectWithValue }
  ) => {
    try {
      const completeResponse: any[] = [];
      // used for loop to make api call in order
      for (const [index, property] of newProperties?.entries()) {
        try {
          const response: any = await crudService.create(
            `${inventoryEndPoint}/`,
            property
          );

          if (response.status === 201) {
            completeResponse.push({
              result: apiSuccess,
              rowNumber: index + 1,
            });
          } else {
            completeResponse.push({ result: apiFail, rowNumber: index + 1 });
          }
        } catch (error) {
          const errorMessage = getErrorMessage(error);

          NotificationManager.error(errorMessage);
          // return rejectWithValue(error.message);
          completeResponse.push({
            result: apiFail,
            rowNumber: index + 1,
            reason: getErrorMessage(error),
          });
        }

        if (onProgress) {
          const percent: number = Math.round(
            ((index + 1) / newProperties.length) * 100
          );
          onProgress(percent);
        }
      }

      // const createPromises = newProperties.map(
      //   async (property: any, index: number) => {
      //     try {
      //       const response: any = await crudService.create(
      //         `${inventoryEndPoint}/`,
      //         property
      //       );
      //       if (response.status === 201) {
      //         return {
      //           result: apiSuccess,
      //           rowNumber: index + 1,
      //         };
      //       } else {
      //         return { result: apiFail, rowNumber: index + 1 };
      //       }
      //     } catch (error) {
      //       const errorMessage = getErrorMessage(error);

      //       NotificationManager.error(errorMessage);
      //       // return rejectWithValue(error.message);
      //       return {
      //         result: apiFail,
      //         rowNumber: index + 1,
      //         reason: getErrorMessage(error),
      //       };
      //     }
      //   }
      // );
      // const responses = await Promise.all(createPromises);
      if (completeResponse.every((res: any) => res.status === 201)) {
        NotificationManager.success("Properties created Successfully.");
      }
      return completeResponse;
    } catch (error) {
      const errorMessage = getErrorMessage(error);

      NotificationManager.error(errorMessage);
      return rejectWithValue(error.message);
    }
  }
);

export const addAdminIndividualInventoryBulk = createAsyncThunk(
  "properties/addAdminIndividualInventoryBulk",
  async (
    {
      properties: newProperties,
      onProgress,
    }: { properties: any; onProgress?: (progress: number) => void },
    { rejectWithValue }
  ) => {
    try {
      const completeResponse: any[] = [];
      // used for loop to make api call in order
      for (const [index, property] of newProperties.entries()) {
        try {
          const response: any = await crudService.create(
            `${individualPropertyEndPoint}/`,
            property
          );

          if (response.status === 201) {
            completeResponse.push({
              result: apiSuccess,
              rowNumber: index + 1,
            });
          } else {
            completeResponse.push({ result: apiFail, rowNumber: index + 1 });
          }
        } catch (error) {
          const errorMessage = getErrorMessage(error);

          NotificationManager.error(errorMessage);

          completeResponse.push({
            result: apiFail,
            rowNumber: index + 1,
            reason: getErrorMessage(error),
          });
        }

        if (onProgress) {
          const percent: number = Math.round(
            ((index + 1) / newProperties.length) * 100
          );
          onProgress(percent);
        }
      }
      // const createPromises = newProperties.map(
      //   async (property: any, index: number) => {
      //     try {
      //       const response: any = await crudService.create(
      //         `${individualPropertyEndPoint}/`,
      //         property
      //       );
      //       if (response.status === 201) {
      //         return {
      //           result: apiSuccess,
      //           rowNumber: index + 1,
      //         };
      //       } else {
      //         return { result: apiFail, rowNumber: index + 1 };
      //       }
      //     } catch (error) {
      //       const errorMessage = getErrorMessage(error);

      //       NotificationManager.error(errorMessage);
      //       // return rejectWithValue(error.message);
      //       return {
      //         result: apiFail,
      //         rowNumber: index + 1,
      //         reason: getErrorMessage(error),
      //       };
      //     }
      //   }
      // );
      // const responses = await Promise.all(createPromises);
      if (completeResponse.every((res: any) => res.status === 201)) {
        NotificationManager.success("Properties created Successfully.");
      }
      return completeResponse;
    } catch (error) {
      const errorMessage = getErrorMessage(error);

      NotificationManager.error(errorMessage);
      return rejectWithValue(error.message);
    }
  }
);

const adminInventorySlice = createSlice({
  name: "properties",
  initialState: initialAdminProperyState,
  reducers: {},

  extraReducers: (builder) => {
    // add admin Property
    builder
      .addCase(addAdminInventoryBulk.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(
        addAdminInventoryBulk.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
        }
      )
      .addCase(addAdminInventoryBulk.rejected, (state: any, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // add admin Individual Property
    builder
      .addCase(addAdminIndividualInventoryBulk.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(
        addAdminIndividualInventoryBulk.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
        }
      )
      .addCase(
        addAdminIndividualInventoryBulk.rejected,
        (state: any, action) => {
          state.loading = false;
          state.error = action.payload as string;
        }
      );
  },
});

export const adminInventoryReducer = adminInventorySlice.reducer;
